module.exports = __webpack_public_path__ + "img/welcome_22.71b5b28e.jpg";